import moment, { Moment } from "moment";
import { useCallback, useEffect, useRef, useState } from "react";

export function InProgressCounter({
  startTime,
  endTime,
}: {
  startTime: Moment;
  endTime: Moment;
}) {
  const [currentTimeElapsedInSecs, setCurrentTimeElapsedInSecs] = useState(
    moment().diff(startTime, "seconds")
  );
  const interval = useRef<NodeJS.Timeout>();
  const meetingLength = endTime.diff(startTime, "seconds");

  const clear = useCallback(() => {
    if (interval.current) {
      clearInterval(interval.current);
    }
  }, []);

  useEffect(() => {
    clear();
    interval.current = setInterval(() => {
      setCurrentTimeElapsedInSecs((s) => {
        const newTime = s + 1;
        if (newTime > meetingLength) {
          clear();
        }
        return newTime;
      });
    }, 1000);
    return () => clear();
  }, [clear, meetingLength]);

  const startsInString = `Now – ${moment
    .duration(currentTimeElapsedInSecs, "seconds")
    .format("mm[m] ss[s]")}`;

  return currentTimeElapsedInSecs > 0 &&
    currentTimeElapsedInSecs <= meetingLength ? (
    <p className="text-accent text-body-sm-heavy">{startsInString}</p>
  ) : null;
}
